export const productPrice = ({ price, withoutPrice }: { price: number | string; withoutPrice: boolean }) => {
    const validPrice = Number(price);

    if (withoutPrice) {
        return '--';
    }

    return validPrice || 'Бесплатно';
};
